namespace GeniuzPOS.InitialData {
    export enum StatusFg {
        nonactive = 0,
        active = 1
    }
    Serenity.Decorators.registerEnumType(StatusFg, 'GeniuzPOS.InitialData.StatusFg');
}
